import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/banks';

const fetchBanks = createAction('fetchBanks');

function fetchBanksSuccess(state, action) {
  const { data } = action.payload;
  state.successFetching = true;
  state.errorFetching = false;
  state.data = data;
}

function fetchBanksError(state) {
  state.successFetching = false;
  state.errorFetching = true;
  state.data = [];
}

const banksReducer = createSlice({
  name: 'banks',
  initialState,
  reducers: {
    fetchBanksSuccess,
    fetchBanksError,
  },
});

export const banksActions = {
  ...banksReducer.actions,
  fetchBanks,
};

export default banksReducer.reducer;
